// extracted by mini-css-extract-plugin
var _1 = "MdG82o4KEEtp8s7DsNEU";
export { _1 as "eventsContainer" }
